import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DocumentMediaModel } from '@phdsoft/common';
import { DocumentsModalComponent } from '../documents-modal/documents-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AssetService } from 'src/app/shared/services/asset.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsSearchService {
  public fileList: File[];
  public documentsList: DocumentMediaModel[] = [];

  constructor(
    private injector: Injector,
    private assetService: AssetService,
    private http: HttpClient,
  ) {

  }

  private async getAssetId(): Promise<string> {
    await this.assetService.getCurrentAsset();
    return this.assetService.assetId;
  }

  public async searchDocuments(search: string): Promise<DocumentMediaModel[]> {
    if (search === "") {
      return [];
    }

    const assetId: string = await this.getAssetId();
    const route:string = 'Media/Search';
    const endpoint:string = `${environment.API_MEDIA}${route}`

    let data = {
      "assetId": assetId,
      "search": search,
    };

    let formDataBody: FormData = new FormData();
    formDataBody.set('searchViewModel', JSON.stringify(data));

    this.documentsList = await firstValueFrom(this.http.post<DocumentMediaModel[]>(endpoint, formDataBody));
    console.log('this.documentsList', this.documentsList);

    return this.documentsList;
  }

  download(document: DocumentMediaModel, css3D?: any): void {
    if (document.DocumentType === 'LINK' && !document.BlobPath.includes('youtu')) {
      window.open(document.BlobPath, '_blank');
    } else {
      this.openDialog(document, css3D);
    }
  }

  openDialog(document: DocumentMediaModel, css3D?: any): void {
    const dialog = this.injector.get(MatDialog);
    let dialogRef = dialog.open(DocumentsModalComponent, {
      width: '90vw',
      height: '85vh',
      maxHeight: '85vh',
      maxWidth: '90vw',
      data: { document: document, css: css3D },
      hasBackdrop: true,
      panelClass: 'modalClass'
    });

    dialogRef.afterClosed().toPromise().then(() => {
      dialogRef = null;
    });
  }

  delete(document: DocumentMediaModel, css3D?: any): void {
    if (document.DocumentType === 'LINK' && !document.BlobPath.includes('youtu')) {
      window.open(document.BlobPath, '_blank');
    } else {
      this.openDialog(document, css3D);
    }
  }

}
